module.exports = __webpack_public_path__ + "img/br38.648725f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br38.jpg
// module id = qp3X
// module chunks = 0